// 指令索引文件
import lazyLoad from './lazyLoad';

export default {
  install(app: any) {
    // 注册图片懒加载指令
    app.directive('lazy-load', lazyLoad);
  }
};